import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from '../../../services/authservices.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-housing-hub',
  templateUrl: './housing-hub.component.html',
  styleUrls: ['./housing-hub.component.css']
})
export class HousingHubComponent implements OnInit {

  loading = false;
  housingList: any[] = [];
  selectedHouse: any = null;


  constructor(  private authService: AuthservicesService,
  private modalService: NgbModal
) {}

  ngOnInit(): void {
    this.getHousingPosts();
  }

  getHousingPosts() {
  this.loading = false;

  this.authService.getMyHousingPosts().subscribe(
    (res: any) => {
      console.log('Housing Response:', res);

      this.housingList = res?.items || [];
      this.loading = true;
    },
    (error) => {
      this.loading = true;
      this.authService.successMessage(error?.error?.message, 'error');
    }
  );
}

openDetailsModal(modal: any, house: any) {
  this.selectedHouse = house;
  this.modalService.open(modal, { size: 'lg', centered: true });
}
}